import React from 'react';
import type { FormInstance } from 'antd';
import { Form } from 'antd';
import { RibbonIconButton } from '../bookDefaultStyles/WordStyleRibbon';
import { styleFieldName } from '../../utils/styleFormFieldNames';
import { ALL_BORDER_SIDES, type BorderSide } from '../../utils/borderSides';

type Props = {
  form: FormInstance;
  namePrefix?: string | string[];
};

const BORDER_SIDE_OPTIONS: Array<{ value: BorderSide; title: string; label: string }> = [
  { value: 'top', title: 'Top border', label: 'T' },
  { value: 'right', title: 'Right border', label: 'R' },
  { value: 'bottom', title: 'Bottom border', label: 'B' },
  { value: 'left', title: 'Left border', label: 'L' },
];

const BorderSideButtonGroup: React.FC<{
  value?: BorderSide[];
  onChange?: (value: BorderSide[]) => void;
}> = ({ value = [...ALL_BORDER_SIDES], onChange }) => {
  const selected = new Set(value);

  const toggle = (side: BorderSide) => {
    const next = new Set(selected);
    if (next.has(side)) {
      next.delete(side);
    } else {
      next.add(side);
    }
    onChange?.(ALL_BORDER_SIDES.filter((item) => next.has(item)));
  };

  return (
    <div className="word-ribbon-inline">
      {BORDER_SIDE_OPTIONS.map(({ value: side, title, label }) => (
        <RibbonIconButton
          key={side}
          title={title}
          active={selected.has(side)}
          onClick={() => toggle(side)}
        >
          {label}
        </RibbonIconButton>
      ))}
    </div>
  );
};

export const BorderSideToggleButtons: React.FC<Props> = ({ form, namePrefix }) => {
  const field = styleFieldName(namePrefix, 'borderSides');
  const value = Form.useWatch(field, form) as BorderSide[] | undefined;

  return (
    <Form.Item name={field} initialValue={[...ALL_BORDER_SIDES]} noStyle>
      <BorderSideButtonGroup value={value} onChange={(next) => form.setFieldValue(field, next)} />
    </Form.Item>
  );
};
